@if (!loading) {
  <div class="qr-codes-header">
    <div class="page-title">Public Outreach Links</div>
    @if (outreachLinks.length > 0) {
      <div class="page-size">
        <app-page-size
          [pageSize]="pageSize"
          [selectId]="'qr-codes-table'"
          (pageSizeChanged)="onPageSizeChange($event)"
        ></app-page-size>
      </div>
    }
  </div>

  <div class="filter-search-section">
    <div class="page-filter">
      <app-filter
        [filterBy]="filterBy"
        [label]="'Link Status:'"
        [filterByOptions]="filterByOptions"
        (filterByChanged)="onFilterByChange($event)"
      ></app-filter>
    </div>

    <div class="search-section-wrapper" id="tour-link-search">
      <app-search-input
        [placeholder]="'Search ...'"
        [(searchQuery)]="searchQuery"
        (searchQueryChange)="onSearchQueryChange($event)"
      ></app-search-input>
    </div>
  </div>

  <!-- <div class="search-section-wrapper">
    <div class="search-section">
      <app-svg-icon [iconName]="'search.svg'" class="svg"></app-svg-icon>
      <input
        type="text"
        placeholder="Search Links..."
        [(ngModel)]="searchQuery"
        (ngModelChange)="onSearchQueryChange($event)"
      />
    </div>
  </div> -->

  <div class="qr-codes-wrapper">
    <div class="left-section">
      <div class="all-section">
        <div class="head-text">Outreach Links</div>
        <div class="right-section-buttons">
          <div class="create-btn">
            <a
              href="javascript:void(0);"
              (click)="showCreatePopup = true"
              id="tour-links-generate"
            >
              <app-svg-icon
                [iconName]="'add.svg'"
                [height]="'18px'"
                [width]="'18px'"
                [style.fill]="'#fff'"
                [style.margin-right]="'5px'"
              ></app-svg-icon>
              <span>Generate Link</span>
            </a>
          </div>
        </div>
      </div>
      <div class="results-wrapper">
        @for (link of outreachLinks; let i = $index; track $index) {
          <div
            class="each-result"
            (click)="onViewDetails(link)"
            (keyup.enter)="onViewDetails(link)"
            (keyup.space)="onViewDetails(link)"
            tabindex="0"
            role="button"
            [attr.aria-label]="'View details for ' + link.name"
            [id]="'tour-outreach-item-' + i"
          >
            <div class="qr-details">
              <div class="date">
                {{ link.created_on_utc | date: "medium" }}
              </div>
              <div class="name">{{ link.name }}</div>
              <!-- <div class="url">{{ qrCode.url }}</div> -->
              <div class="user">
                Created by:
                <b
                  >{{ link.created_by_user.first_name }}
                  {{ link.created_by_user.last_name }}</b
                >
                <!-- • Scans:
                <b>{{ qrCode.scans_count }}</b> -->
              </div>
            </div>

            <div class="right-actions">
              <div
                [id]="'tour-link-status-' + i"
                class="status-badge"
                [class]="link.is_active ? 'active' : 'inactive'"
              >
                <span class="status-dot"></span>
                <span class="status-text">{{
                  link.is_active ? "Active" : "Inactive"
                }}</span>
              </div>
              <a
                [id]="'tour-link-delete-' + i"
                href="javascript:void(0);"
                class="qr-delete-icon"
                title="Delete"
                (click)="onDeleteLink(link); $event.stopPropagation()"
              >
                <app-svg-icon
                  [iconName]="'delete.svg'"
                  [height]="'16px'"
                  [width]="'14px'"
                  [style.fill]="'#334ea5'"
                ></app-svg-icon>
              </a>
              <div class="chevron-right">
                <app-svg-icon
                  [iconName]="'next.svg'"
                  [height]="'16px'"
                  [width]="'16px'"
                  [style.fill]="'#9ca3af'"
                ></app-svg-icon>
              </div>
            </div>
          </div>
        } @empty {
          <div class="no-data-wrapper">
            <div class="no-data">
              <app-svg-icon
                [iconName]="'no-data.svg'"
                [height]="'100px'"
                [width]="'100px'"
              ></app-svg-icon>
              <div class="text-holder">No Links found</div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
  @if (outreachLinks.length > 0) {
    <app-pagination
      [currentPage]="currentPage"
      [pageSize]="pageSize"
      [totalItems]="totalLinks"
      (pageChanged)="onPageChange($event)"
    ></app-pagination>
  }
} @else {
  <div class="qr-codes-header">
    <div class="page-title">Public Outreach Links</div>
  </div>
  <div class="qr-codes-wrapper">
    <div class="left-section">
      <div class="all-section">
        <div class="right-section-buttons"></div>
      </div>
      <div class="results-wrapper">
        <div class="each-result">
          <div class="qr-details">
            <div class="skeleton-box"></div>
            <div class="skeleton-box"></div>
            <div class="skeleton-box"></div>
          </div>
        </div>
        <div class="each-result">
          <div class="qr-details">
            <div class="skeleton-box"></div>
            <div class="skeleton-box"></div>
            <div class="skeleton-box"></div>
          </div>
        </div>
        <div class="each-result">
          <div class="qr-details">
            <div class="skeleton-box"></div>
            <div class="skeleton-box"></div>
            <div class="skeleton-box"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
}

@if (showCreatePopup) {
  <app-outreach-link-create
    (cancelled)="showCreatePopup = false"
    (popupClosed)="onClosePopup($event)"
    (linkGenerated)="onLinkGenerated($event)"
  ></app-outreach-link-create>
}

@if (showDeleteConfirmPopup) {
  <app-popup
    [heading]="'Are you sure you want to delete this link?'"
    [confirmText]="'Delete'"
    [cancelText]="'Cancel'"
    (confirmClicked)="onConfirmDelete()"
    (cancelClicked)="showDeleteConfirmPopup = false"
  >
    <div class="lead-unassign-popup-content">
      {{ deletePopupLink.name }}
    </div>
  </app-popup>
}

@if (showDetailsPopup && selectedLinkId) {
  <app-outreach-link-details
    [outreachLinkId]="selectedLinkId"
    (linkDeleted)="onLinkDeleted($event)"
    (linkUpdated)="onLinkUpdated($event)"
    (linkStatusChanged)="onLinkStatusChange($event)"
    (popupClosed)="onDetailsPopupClosed()"
  ></app-outreach-link-details>
}
